import script from "./KanbanStagesEditor.vue?vue&type=script&setup=true&lang=js"
export * from "./KanbanStagesEditor.vue?vue&type=script&setup=true&lang=js"

import "./KanbanStagesEditor.vue?vue&type=style&index=0&id=219c482a&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-219c482a"]])

export default __exports__